// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__365Y5","delete":"styles_delete__3dQU-","update":"styles_update___l2dS","add":"styles_add__1Omar"};